export default "__VITE_ASSET__ef681ef2__"